export const theme = {
  colors: {
    primary: '#000000',
    black: '#000000',
    white: '#FFFFFF',
    text: '#000', // Surchargé pour correspondre au défaut SASS
    lightgrey: '#f7f7f7',
    grey: '#a2a2a2',
    darkgrey: '#3c3c3c',
    midgrey: '#8a8a8a',
    border: '#8f8f8f',
    border2: '#080808',
    focus: '#147ec1',
    green: '#48BB46',
    yellow: '#EBB60E',
    orange: '#ff8000',
    darkRed: '#FF0000',
  },
  spacing: 20,
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    tablet_landscape: '992px',
    laptop: '1200px',
    desktop: '1440px',
  },
  logoRatio: 1110/1996,
  maxWidth: 1704, // Correspond au défaut SASS
  hPadding: 20
};

export default theme;
